import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { trackLead } from '../utils/analytics';
const faqs = [{
  question: 'Jsou rady skutečně 100% ZDARMA?',
  answer: 'Ano, veškeré rady a tipy v tomto videu jsou zcela zdarma. Mým cílem je pomoci co nejvíce začátečníkům vyhnout se chybám, které jsem dělal já.'
}];
export const RadyPage: React.FC = () => {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleCtaClick = () => {
    trackLead('Free Tips Rady', 'free_rady');
    window.location.href = 'https://buy.stripe.com/fZu3cucIH7LY6wt2vAg7e03';
  };
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-green-500/30" data-id="element-1786">
      {/* Header */}
      <header className="py-6 text-center border-b border-gray-800/50" data-id="element-1787"></header>

      <main className="max-w-2xl mx-auto px-4 py-8 md:py-12" data-id="element-1788">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-1789">
          {/* Hero Image */}
          <div className="relative rounded-2xl overflow-hidden mb-8 shadow-2xl shadow-black/50 ring-1 ring-white/10" data-id="element-1790">
            <img src="https://cdn.magicpatterns.com/uploads/gADNuGzfanmLPdspUdb2ZU/openart-image_97OQdk2p_1773075169549_raw_(2).jpg" alt="Transformace – před a potom" className="w-full h-auto object-cover" data-id="element-1791" />

            {/* Badges */}
          </div>

          {/* Copy */}
          <div className="space-y-6 mb-10" data-id="element-1792">
            <h1 className="text-2xl md:text-3xl font-bold leading-tight text-white" data-id="element-1793">
              🚀 Rady, které mi pomohly dosáhnout vysněné postavy a jak z
              úplného{' '}
              <span style={{
              fontFamily: "'Playfair Display', serif"
            }} className="text-green-500 italic" data-id="element-1794">
                začátečníka
              </span>{' '}
              jsem nabral 23 kg svalů 🔥
            </h1>

            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-1795">
              V následujícím videu získáš{' '}
              <strong className="text-white" data-id="element-1796">znalosti</strong>, díky kterým
              budeš vědět víc než{' '}
              <strong className="text-white" data-id="element-1797">95 % začátečníků</strong> v
              posilovně. Díky tomu{' '}
              <strong className="text-white" data-id="element-1798">výrazně zvýšíš svou šanci</strong>{' '}
              dosáhnout vysněné postavy a už během{' '}
              <strong className="text-white" data-id="element-1799">90 dní</strong> můžeš být{' '}
              <strong className="text-white" data-id="element-1800">
                mnohem blíž tělu, o kterém jsi vždycky snil
              </strong>
              .
            </p>

            <div className="flex items-start gap-2 text-base md:text-lg text-gray-300" data-id="element-1801">
              <span className="flex-shrink-0" data-id="element-1802">✅</span>
              <span data-id="element-1803">
                Bez nutnosti{' '}
                <strong className="text-white" data-id="element-1804">extrémních diet</strong> a{' '}
                <strong className="text-white" data-id="element-1805">
                  extrémně dlouhých tréninků v posilovně
                </strong>
                .
              </span>
            </div>

            {/* Client results heading */}
            <h2 className="text-2xl md:text-3xl font-bold leading-tight text-white pt-4" data-id="element-1806">
              Jak tyto{' '}
              <span style={{
              fontFamily: "'Playfair Display', serif"
            }} className="text-green-500 italic" data-id="element-1807">
                stejné rady
              </span>{' '}
              pomohly i mým klientům dosáhnout jejich vysněné postavy🔥
            </h2>

            {/* Client transformation photos */}
            <div className="space-y-4" data-id="element-1808">
              {/* Client 1 */}
              <div className="relative rounded-xl overflow-hidden ring-1 ring-white/10 shadow-lg" data-id="element-1809">
                <div className="grid grid-cols-2 gap-0" data-id="element-1810">
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1811">
                    <img src="https://cdn.magicpatterns.com/uploads/3aukJj5dQN8w5xwdnQ2pkG/Screenshot_2026-03-09_at_19.55.07.png" alt="Klient před" className="w-full h-full object-cover object-center" data-id="element-1812" />
                    <div className="absolute bottom-2 left-2 bg-red-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1813">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1814">
                        PŘED
                      </span>
                    </div>
                  </div>
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1815">
                    <img src="https://cdn.magicpatterns.com/uploads/3wwHV1mHRu4YoWB92ofmE6/Screenshot_2025-12-27_at_20.25.37.png" alt="Klient po" className="w-full h-full object-cover object-center" data-id="element-1816" />
                    <div className="absolute bottom-2 right-2 bg-green-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1817">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1818">
                        PO
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Client 2 */}
              <div className="relative rounded-xl overflow-hidden ring-1 ring-white/10 shadow-lg" data-id="element-1819">
                <div className="grid grid-cols-2 gap-0" data-id="element-1820">
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1821">
                    <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_UfvYMToM_864x1152_1766861258705.webp" alt="Klient před" className="w-full h-full object-cover object-[center_35%]" data-id="element-1822" />
                    <div className="absolute bottom-2 left-2 bg-red-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1823">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1824">
                        PŘED
                      </span>
                    </div>
                  </div>
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1825">
                    <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_UgQvynrt_800x1264_1766948855818.webp" alt="Klient po" className="w-full h-full object-cover object-center" data-id="element-1826" />
                    <div className="absolute bottom-2 right-2 bg-green-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1827">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1828">
                        PO
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Client 3 */}
              <div className="relative rounded-xl overflow-hidden ring-1 ring-white/10 shadow-lg" data-id="element-1829">
                <div className="grid grid-cols-2 gap-0" data-id="element-1830">
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1831">
                    <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_7A0OcnL3_800x1248_1766860727661.webp" alt="Klient před" className="w-full h-full object-cover object-[center_20%]" data-id="element-1832" />
                    <div className="absolute bottom-2 left-2 bg-red-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1833">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1834">
                        PŘED
                      </span>
                    </div>
                  </div>
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1835">
                    <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_h8HK1UaO_976x1024_1766861040822.webp" alt="Klient po" className="w-full h-full object-cover object-center" data-id="element-1836" />
                    <div className="absolute bottom-2 right-2 bg-green-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1837">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1838">
                        PO
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="mb-16" data-id="element-1839">
            <button onClick={handleCtaClick} className="w-full bg-green-500 hover:bg-green-400 text-black font-black text-lg py-4 rounded-xl transition-all duration-300 shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)] active:scale-[0.98]" data-id="element-1840">
              CHCI RADY ZDARMA!
            </button>
          </div>

          {/* FAQ Section */}
          <div className="mb-16" data-id="element-1841">
            <h2 className="text-2xl font-bold text-white mb-6" data-id="element-1842">
              Frequently Asked Questions
            </h2>
            <div className="space-y-4" data-id="element-1843">
              {faqs.map((faq, index) => <div key={index} className="border-b border-gray-800 pb-4" data-id="element-1844">
                  <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full flex items-center justify-between text-left py-2 hover:text-gray-300 transition-colors" data-id="element-1845">
                    <span className="font-medium text-lg" data-id="element-1846">{faq.question}</span>
                    {openFaq === index ? <MinusIcon className="w-5 h-5 text-gray-400" data-id="element-1847" /> : <PlusIcon className="w-5 h-5 text-gray-400" data-id="element-1848" />}
                  </button>
                  <AnimatePresence data-id="element-1849">
                    {openFaq === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-1850">
                        <p className="text-gray-400 pt-2 pb-4 leading-relaxed" data-id="element-1851">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
            </div>
          </div>

          {/* Footer Link */}
          <div className="text-center pb-8" data-id="element-1852">
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 underline transition-colors" data-id="element-1853">
              Privacy Policy
            </a>
          </div>
        </motion.div>
      </main>
    </div>;
};